import { render } from "./MultiSelectList.vue?vue&type=template&id=0df8560a&scoped=true"
import script from "./MultiSelectList.vue?vue&type=script&lang=js"
export * from "./MultiSelectList.vue?vue&type=script&lang=js"

import "./MultiSelectList.vue?vue&type=style&index=0&id=0df8560a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0df8560a"]])

export default __exports__